import { Box, CircularProgress, FormHelperText, Typography } from '@mui/material';
import { FormikConfig } from 'formik';
import React from 'react';
import Details from '../../../components/Details/Details';
import FilterComponentV2 from '../../../components/TablegridWithFilters/FilterComponent/FilterComponentv2';
import { getParavoloStatus } from '../../../lib/fetchers';
import { eliminateOjectNotTruthyValues, matchRefsWithData } from '../../../lib/helperFuncs';
import { paravoloStatusRefs } from '../../../lib/static/details/staticDetails';
import { paravoloStatusFields } from '../../../lib/static/filters/filterFields';
import { paravoloStatusIinitialValues } from '../../../lib/static/filters/initialValues';
import { paravoloStatuseValidationSchema } from '../../../lib/static/filters/ValidationSchema';
import Theme from '../../../Themes/main.theme';

const ParavoloStatusInfo = () => {
  const [data, setData] = React.useState({
    paravoloStatus: {
      statusId: '',
      statusName: ''
    },
    moneyReturnStatus: {
      statusId: '',
      statusName: ''
    }
  });
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string>();

  const onSubmit = async (values: FormikConfig<any>) => {
    setIsLoading(true);
    try {
      const response = await getParavoloStatus(eliminateOjectNotTruthyValues(values));
      setError('');
      setData(response.data);
    } catch (error: any) {
      console.error(error);
      if (error.response.status === 400) {
        setError(error.response.data.message);
      }
    }
    setIsLoading(false);
  };

  const details_1 = matchRefsWithData(data?.paravoloStatus, paravoloStatusRefs);
  const details_2 = matchRefsWithData(data?.moneyReturnStatus, paravoloStatusRefs);

  return (
    <>
      <Typography sx={{my: 2}} variant='h2'
        color={Theme?.labelColor?.main}>Στοιχεία Ηλεκτρονικού Παραβόλου</Typography>
      <FormHelperText sx={{mb: 1}}>
        <Typography variant='subtitle1'>
          <ul>
            <li>
              Το παράβολο πάει σε κατάσταση  <span style={{fontWeight: 'bold'}}>ΑΚΥΡΩΜΕΝΟ</span>, MONO στην περίπτωση που
              <span style={{fontWeight: 'bold'}}> δεν πληρωθεί σε διάστημα 60 ημερών</span> από την δημιουργία του.
            </li>
            <li>
              Τα παράβολα για τα οποία έχει γίνει <span style={{fontWeight: 'bold'}}>αίτημα επιστροφής</span> από τον πολίτη ή από τον φορέα βρίσκεται 
              σε κατάσταση  <span style={{fontWeight: 'bold'}}>ΔΕΣΜΕΥΜΕΝΟ</span>.
            </li>
          </ul>
        </Typography>
      </FormHelperText>
      <FilterComponentV2
        title='Φίλτρα Αναζήτησης Κατάστασης Παραβόλου'
        validationSchema={paravoloStatuseValidationSchema}
        filterFields={paravoloStatusFields}
        initialValues={paravoloStatusIinitialValues}
        resetFilters={true}
        changeFilters={filterValues => onSubmit(filterValues)}
        validateOnBlur={false}
      />
      <Box mt={5} >
        {isLoading
          ? <Box sx={{ display: 'flex', justifyContent: 'center'}}>
            <CircularProgress />
          </Box>
          : error
            ? <Typography variant='h4' display='flex'
              justifyContent='center'>
              {error}
            </Typography> 
            : data.paravoloStatus.statusId
              ? <Box height='100%'>
                <Details title='Κατάσταση παραβόλου' rows={details_1}/>
                <Details title='Κατάσταση επιστροφής χρημάτων παραβόλου' rows={details_2}/>
              </Box> 
              : null 
        }
      </Box>
    </>
  );
};

export default ParavoloStatusInfo;